export const COMPILED_PLAYLIST_ACTIVATION_URL = 'https://ativacao.auroraflux.net/ativar-lista';

export function normalizePlaylistActivationUrl(candidate?: string | null): string | null {
  const raw = String(candidate || '').trim();
  if (!raw) return null;
  const match = /^(https?):\/\/([^/?#]+)(\/[^?#]*)?$/i.exec(raw);
  if (!match) return null;

  const authority = match[2];
  if (!authority || authority.indexOf('@') >= 0 || /\s/.test(authority)) return null;

  // Validate an optional port without relying on URL/URLSearchParams, which is
  // incomplete on Samsung Tizen 3 / Chrome 47.
  let port = '';
  if (authority.charAt(0) === '[') {
    const ipv6 = /^(\[[0-9a-f:.]+\])(?::(\d+))?$/i.exec(authority);
    if (!ipv6) return null;
    port = ipv6[2] || '';
  } else {
    const host = /^([a-z0-9.-]+)(?::(\d+))?$/i.exec(authority);
    if (!host || !host[1]) return null;
    port = host[2] || '';
  }
  if (port) {
    const portNumber = parseInt(port, 10);
    if (portNumber < 1 || portNumber > 65535) return null;
  }

  const path = (match[3] || '').replace(/\/+$/, '');
  return `${match[1].toLowerCase()}://${authority}${path}`;
}

export function resolvePlaylistActivationUrl(
  backendValue?: string | null,
  lastValidValue?: string | null,
): string {
  return normalizePlaylistActivationUrl(backendValue)
    || normalizePlaylistActivationUrl(lastValidValue)
    || COMPILED_PLAYLIST_ACTIVATION_URL;
}

export function buildPlaylistActivationUrl(baseUrl: string, deviceCode: string, password: string): string {
  const resolvedBase = resolvePlaylistActivationUrl(baseUrl);
  const code = deviceCode.toUpperCase().replace(/[^A-Z0-9]/g, '');
  const pwd = password.toUpperCase().replace(/[^A-Z0-9]/g, '');
  return `${resolvedBase}?code=${encodeURIComponent(code)}&pwd=${encodeURIComponent(pwd)}`;
}
